import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { pushEcommerceDetail as gtmPushEcommerceDetail } from '../../utils/Gifts/gtm';
import HtmlHead from '../../components/01_atoms/HtmlHead';
import Paragraphs from '../../components/02_molecules/Paragraphs';

import '../../styles/gifts/sass/theme.scss';

const GiftsProductPage = ({ entity: product }) => {
  useEffect(() => {
    gtmPushEcommerceDetail(product);
  }, []);

  const blocks = [...product.blocks];

  return (
    <div>
      <HtmlHead metatags={product.metaTags} pageTitle={product.title} />
      <Paragraphs blocks={blocks} layout={'centered'} />
    </div>
  );
};

GiftsProductPage.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default GiftsProductPage;
